import { yupResolver } from '@hookform/resolvers/yup';
import PhoneIcon from '@mui/icons-material/Phone';
import { Avatar, Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { saveUser } from 'wisestep-api';
import {
  ControlledTextInput,
  IUserDTO,
  WsButton,
  WsColors,
  WsDialog,
  WsDialogSize,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';
import { object, number } from 'yup';

import { useUserContext } from '../../../context';
import { success, failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

const validationSchema = object().shape({
  phoneNum: number()
    .typeError("That doesn't look like a phone number")
    .positive("A phone number can't start with a minus")
    .integer("A phone number can't include a decimal point")
    .required('Phone number is required'),
});

const PhoneNumberPopup = () => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const setNotification = useNotificationStore((state) => state.setNotification);
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: {
      phoneNum: '',
    },
  };
  const methods = useForm(formOptions);
  const { handleSubmit, reset } = methods;
  const [openStatusModal, setOpenStatusModal] = useState<boolean>(false);
  const onReset = () => {
    setOpenStatusModal(false);
    reset();
  };

  const onFormSubmit = async (data: FieldValues) => {
    const tempData = loggedInUser;
    tempData.phoneNumber = data.phoneNum;
    try {
      await saveUser(tempData);
      setOpenStatusModal(false);
      setNotification(success('Phone number updated successfully!'));
    } catch (error) {
      setNotification(failed('Failed to save profile details!'));
    }
  };

  useEffect(() => {
    if (loggedInUser && isEmpty(loggedInUser?.phoneNumber)) setOpenStatusModal(true);
  }, [loggedInUser]);

  return (
    <>
      {openStatusModal && (
        <WsDialog openDialog={true} size={WsDialogSize.SMALL}>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onFormSubmit)}>
              <Grid container xs={12} pt={10} pb={4} justifyContent="center">
                <Grid item>
                  <Avatar sx={{ bgcolor: WsColors.TheBlues600, width: 56, height: 56 }}>
                    <PhoneIcon sx={{ color: WsColors.White, fontSize: '40px' }} />
                  </Avatar>
                </Grid>
              </Grid>

              <Grid container xs={12} pb={4} justifyContent="center">
                <Grid item>
                  <WsTypography
                    variant={WsTypoVariants.TITLE}
                    color={WsTypoColors.BLACK}
                    bold={true}
                  >
                    Enter Phone Number to complete profile details
                  </WsTypography>
                </Grid>
              </Grid>
              <Grid container xs={12} pb={3} justifyContent="center">
                <Grid item xs={6}>
                  <ControlledTextInput
                    name="phoneNum"
                    labelText=""
                    placeholder="Eg, 99999 - 99999"
                    variant="outlined"
                    autoComplete="phoneNum"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container p={1} justifyContent="flex-end" pb={3}>
                <Stack p={1} spacing={2} direction="row">
                  <WsButton variant="outlined" size="large" onClick={onReset}>
                    Skip
                  </WsButton>
                  <WsButton variant="contained" size="large" type="submit">
                    Submit
                  </WsButton>
                </Stack>
              </Grid>
            </form>
          </FormProvider>
        </WsDialog>
      )}
    </>
  );
};

export default PhoneNumberPopup;
